import { render, staticRenderFns } from "./SaveReport.vue?vue&type=template&id=2ab2f1a4&scoped=true&"
import script from "./SaveReport.vue?vue&type=script&lang=js&"
export * from "./SaveReport.vue?vue&type=script&lang=js&"
import style0 from "./SaveReport.vue?vue&type=style&index=0&id=2ab2f1a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab2f1a4",
  null
  
)

export default component.exports